import { render, staticRenderFns } from "./ImageGrid.vue?vue&type=template&id=04b9615c&"
import script from "./ImageGrid.vue?vue&type=script&lang=ts&"
export * from "./ImageGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports